import { Link } from "react-router-dom";
import { useApi, useSeo } from "../lib/settings";
import { SITE } from "../lib/seo";
import { useList, PLAYED } from "../lib/store";
import { Rail } from "../components/Rail";
import { AdSlot } from "../components/AdSlot";
import { api } from "../lib/api";
import { useEffect, useState } from "react";

function PlayedRail() {
  const played = useList(PLAYED);
  const [items, setItems] = useState([]);
  useEffect(() => {
    if (!played.length) {
      setItems([]);
      return;
    }
    api.post("/games/by-slugs", { slugs: played.slice(0, 20) }).then((r) => setItems(Array.isArray(r.data) ? r.data : [])).catch(() => {});
  }, [played]);
  return <Rail id="played" title="Giochi giocati di recente" url="/giocati" items={items} />;
}

export default function Home() {
  const { data, loading } = useApi("/home", []);
  useSeo({
    path: "/",
    jsonld: SITE && {
      "@context": "https://schema.org",
      "@type": "WebSite",
      name: "Giochi.Gratis",
      url: `${SITE}/`,
      inLanguage: "it-IT",
      potentialAction: { "@type": "SearchAction", target: `${SITE}/cerca?q={search_term_string}`, "query-input": "required name=search_term_string" },
    },
  });
  const rails = Array.isArray(data?.rails) ? data.rails : [];
  const cats = Array.isArray(data?.categories) ? data.categories : [];
  const tags = Array.isArray(data?.tags) ? data.tags : [];
  return (
    <div className="content" data-testid="home-page">
      <div className="page-title">
        <h1>Giochi Online Gratis</h1>
        <p>{data?.total ? `${data.total.toLocaleString("it-IT")} giochi gratis da giocare subito, senza download!` : "I migliori giochi gratis per te"}</p>
      </div>
      <AdSlot name="header_728" className="ad728list" />
      <div className="gg-rails">
        <PlayedRail />
        {loading && <div className="gg-empty"><i className="fa-solid fa-spinner fa-spin" /></div>}
        {rails.map((r) => (
          <Rail key={r.id} id={r.id} title={r.title} url={r.url} items={r.items} />
        ))}
      </div>
      {cats.length > 0 && (
        <div className="home-categories-tags-container" data-testid="home-categories-tags">
          <ul className="home-categories">
            {cats.map((c) => (
              <li key={c.slug}><Link to={`/categoria/${c.slug}`} data-testid={`home-cat-${c.slug}`}>{c.name}</Link></li>
            ))}
            <li><Link to="/categorie">Altre categorie</Link></li>
          </ul>
          <ul className="home-tags">
            {tags.map((t) => (
              <li key={t.slug}><Link to={`/tag/${t.slug}`}>{t.name}</Link></li>
            ))}
            <li><Link to="/tags">Altri tag</Link></li>
          </ul>
        </div>
      )}
    </div>
  );
}
